import { render, staticRenderFns } from "./MadLibs.vue?vue&type=template&id=264cf6b9&scoped=true&"
import script from "./MadLibs.vue?vue&type=script&lang=js&"
export * from "./MadLibs.vue?vue&type=script&lang=js&"
import style0 from "./MadLibs.vue?vue&type=style&index=0&id=264cf6b9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "264cf6b9",
  null
  
)

export default component.exports